import "./Toy.css"
import Product1 from "../Components/Product1"
import Toy1 from "../images/toy1.jpg"
import Toy2 from "../images/toy2.jpg"
import Toy3 from "../images/toy3.jpg"
import Toy4 from "../images/toy4.jpg"
import Toy5 from "../images/toy5.jpg"
import Toy6 from "../images/toy6.jpg"
import Toy7 from "../images/toy7.jpg"
import Toy8 from "../images/toy8.jpg"
import Toy9 from "../images/toy9.jpg"


export default function Toy() {

  return (
    <div className="stdivinhome">
      <div className="add"><img src={Toy9} /></div>
      <div className="home">

        <div className="home__prd">

          <div className="home__prd1">

            <Product1  id="Toy1"prdName="TRIGGER GUN" img={Toy1} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"  ></Product1>
              <Product1 id="Toy2" prdName="Shumee Wooden Rainbow Stacking Rings Game" img={Toy2} price="Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1> 

          </div>

          <div className="home__prd1">

          
          <Product1  id="Toy3"prdName="TEDDY BEAR" img={Toy3} price="Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
            <Product1  id="Toy4"prdName="RUBICS CUDE" img={Toy4} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
        

          </div>

        </div>


        <div className="home__prd">

          <div className="home__prd1">

            <Product1  id="Toy5"prdName="PUZZLE CUBES" img={Toy5} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"  ></Product1>
            <Product1  id="Toy6"prdName="TABLE FOOT BALL POOL" img={Toy6} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

          <div className="home__prd1">

            <Product1  id="Toy7" prdName="REMOTE CAR" img={Toy7} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
            <Product1  id="Toy8"prdName="RED SOLIMO" img={Toy8} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

        </div>

      </div>

    </div>
  )
}